module.exports = __webpack_public_path__ + "media/images/icons/outlined/sisternode-830539db1b68e386288f1a0fa4c0b2f9.svg";